import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M8.62196 0.265172L15.7425 7.59868C16.0858 7.95225 16.0858 8.5258 15.7425 8.87936L14.9119 9.73478C14.5689 10.088 14.0135 10.0883 13.6698 9.73629L8.00018 3.92419L2.33019 9.73591C1.98651 10.0883 1.43106 10.0876 1.08811 9.7344L0.257485 8.87898C-0.0858287 8.52542 -0.0858287 7.95187 0.257485 7.59831L7.37841 0.265172C7.72172 -0.0883907 8.27865 -0.0883907 8.62196 0.265172Z"
      fill={props.fill || '#B3B3B3'}
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const ArrowIcon = memo(ForwardRef);
export default ArrowIcon;
